import Canvas from './Canvas';
import React from 'react';
import update from 'immutability-helper';
class RandomCanvas extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            canvasData: {
                background: '#FFFFFF',
                pen: {
                    paths: [
                        {
                            color: props.color,
                            points: []
                        }
                    ],
                },
                marker: {
                    paths: []
                },
                existing: [],
            }
        };
    }

    componentDidMount() {
        this.addRandom();
        this.timerID = setInterval(() => this.addRandom(), this.props.updateInterval);
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    addRandom() {
        this.setState((state, props) => {
            return update(state, {
                canvasData: {
                    pen: {
                        paths: {
                            [state.canvasData.pen.paths.length-1]: {
                                points: {
                                    $push: [{
                                        x: Math.random(),
                                        y: Math.random()
                                    }]
                                },
                            },
                        },
                    },
                }
            });
        })
    }

    render() {
        return (
            <Canvas data={this.state.canvasData} width={this.props.width} hideCursor={false} drawingStrategy={this.props.drawingStrategy} />
        );
    }
}

export default RandomCanvas;
